<div class="table" [style]="{ 'padding-bottom': '32px' }">
  <div class="p-d-flex p-jc-between p-ai-end personalize-filter">
    <div #toolbar class="page-action-container p-d-flex p-jc-center p-ai-start">
      <button
        *ngIf="showDelete"
        pButton
        label="{{ 'Delete' | translate }}"
        icon="pi pi-delete"
        class="p-button-action p-button-outlined p-content-button mr-10"
        (click)="onDeleteBtnClick()"
      ></button>
      <div class="field-filter-container p-d-flex p-ai-end p-jc-center p-mr-0">
        <div class="p-filter" #filter>
          <button
            *ngIf="(complex || showColumnFilter) && !forceCloseColumnFilter"
            pButton
            label="{{ 'Filter Columns' | translate }}"
            icon="pi pi-filter"
            class="p-button-action p-button-outlined p-content-button mr-10"
            (click)="onColumnFilterBtnClick($event)"
          ></button>
        </div>
      </div>
      <ng-container *ngIf="toolbarTemplate">
        <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
      </ng-container>
    </div>
    <p-multiSelect
      *ngIf="complex || showColumnFilter"
      sigvDropdownSetting
      [(ngModel)]="selectedFields"
      [options]="filterColumnOptions"
      [appendTo]="filter"
      (onPanelHide)="onMultiSelectClose($event)"
      optionLabel="label"
      optionValue="value"
      [overlayVisible]="isOpenColumnFilter"
      [showToggleAll]="false"
      (onChange)="onMultiSelectChange($event)"
      [style]="{ width: '300px' }"
    >
      <ng-template pTemplate="item" let-item>
        {{ item.label | translate }}
      </ng-template>
    </p-multiSelect>
    <button
      *ngIf="
        !forceCloseInformation &&
        (sort || reorderableColumns || showInformation)
      "
      [useTimeoutChecker]="false"
      pButton
      icon="pi pi-teaching"
      tooltipEvent="focus"
      [escape]="false"
      tooltipStyleClass="p-tool-w400"
      [pTooltip]="tooltipText"
      tooltipPosition="bottom"
      class="p-button-action p-button-outlined p-button-teaching mb-5"
    ></button>
  </div>
  <p-table
    [value]="value"
    [columns]="columns"
    [first]="first"
    (firstChange)="onFirstChange($event)"
    [loading]="loading"
    [resetPageOnSort]="false"
    [reorderableColumns]="reorderableColumns"
    [editMode]="editable ? 'row' : ''"
    [sortMode]="sort ? 'multiple' : ''"
    [selection]="selection"
    (selectionChange)="onSelectionChange($event)"
    [paginator]="paging"
    [lazy]="lazy"
    [rowsPerPageOptions]="rowsPerPageItems"
    [rows]="10"
    paginatorDropdownAppendTo="body"
    [showCurrentPageReport]="true"
    [dataKey]="dataKey"
    [totalRecords]="totalRecords"
    [stateKey]="preferenceKey"
    stateStorage="local"
    currentPageReportTemplate="{{
      (!this.pageData.isMobile
        ? this.currentPageReportTemplate
        : this.mobileReportTemplate
      ) | translate
    }}"
    (onSort)="onTableSort($event)"
    (onPage)="onTablePaging($event)"
    (onColReorder)="onColReorder($event)"
    (onStateRestore)="onTableStateRestore($event)"
    (onStateSave)="onTableStateSave($event)"
    [ngClass]="{
      'p-datatable-scrollable': scrollable,
      'p-datatable-scrollable-both': frozenColCount > 0
    }"
  >
    <ng-template pTemplate="caption">
      <ng-container *ngIf="captionTemplate">
        <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
      </ng-container>
    </ng-template>
    <ng-template *ngIf="frozenColCount == 0" pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngIf="hasFunctionCell" style="width: 120px" />
        <col
          *ngFor="let col of columns"
          [ngStyle]="{ width: col.width ? col.width : '' }"
        />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <ng-container *ngIf="headerTemplate; else defaultHeader">
        <ng-container
          *ngTemplateOutlet="headerTemplate; context: { $implicit: columns }"
        ></ng-container>
      </ng-container>
      <ng-template #defaultHeader>
        <tr *ngIf="isShowHeader">
          <th
            *ngIf="hasFunctionCell"
            [ngStyle]="
              scrollable && frozenColCount > 0
                ? calcFrozenColumnStyles(0, true, true)
                : {}
            "
          >
            <div class="p-d-inline-flex p-ai-center">
              <ng-container *ngIf="selectable && showSelectAll">
                <p-tableHeaderCheckbox
                  *ngIf="checkboxAvalaible"
                  [ngClass]="{
                    'p-datatable-icon-button-space': true,
                    'p-datatable-header-checkbox-selected-some':
                      selection.length > 0 &&
                      selection.length < selectableRows.length
                  }"
                  [disabled]="isReadonly"
                >
                </p-tableHeaderCheckbox>
                <span>{{ 'All' | translate }}</span>
              </ng-container>
            </div>
          </th>
          <ng-container
            *ngIf="!reorderableColumns; else reorderableColumnHeader"
          >
            <th
              *ngFor="let col of columns; let i = index"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sortable"
              [ngStyle]="
                frozenColCount > 0 ? calcFrozenColumnStyles(i, true) : null
              "
            >
              <ng-container
                *ngTemplateOutlet="
                  !columnHeaderContentTemplate
                    ? defaultColumnHeaderContent
                    : columnHeaderContentTemplate;
                  context: { $implicit: col }
                "
              ></ng-container>
              <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
            </th>
          </ng-container>
          <ng-template #reorderableColumnHeader>
            <th
              *ngFor="let col of columns; let i = index"
              pReorderableColumn
              [pReorderableColumnDisabled]="
                (hasFunctionCell ? frozenColCount - 1 : frozenColCount) - i > 0
              "
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sortable"
              [ngStyle]="
                frozenColCount > 0 ? calcFrozenColumnStyles(i, true) : null
              "
            >
              <ng-container
                *ngTemplateOutlet="
                  !columnHeaderContentTemplate
                    ? defaultColumnHeaderContent
                    : columnHeaderContentTemplate;
                  context: { $implicit: col }
                "
              ></ng-container>
              <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
            </th>
          </ng-template>
          <ng-template #defaultColumnHeaderContent let-colInfo>
            {{ colInfo.header | translate }}
          </ng-template>
        </tr>
      </ng-template>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-row
      let-columns="columns"
      let-rowIndex="rowIndex"
      let-expanded="expanded"
      let-editing="editing"
    >
      <ng-container *ngIf="bodyTemplate">
        <ng-container *ngIf="hasFunctionCell; else bodyContainer">
          <ng-container
            *ngIf="displayRowChkboxFunc(row, rowIndex); else unSelectableRow"
          >
            <tr
              [pSelectableRow]="row"
              [pSelectableRowIndex]="rowIndex"
              [pEditableRow]="row"
              [class.p-editing]="editing && showHighlightColor"
              [class.p-highlight]="row.create && showHighlightColor"
            >
              <td
                [ngStyle]="
                  scrollable && frozenColCount > 0
                    ? calcFrozenColumnStyles(0, false, true)
                    : {}
                "
              >
                <div class="p-d-flex p-ai-center p-jc-center">
                  <ng-container *ngIf="selectable">
                    <p-tableCheckbox
                      *ngIf="
                        !editing &&
                        !row.create &&
                        displayRowChkboxFunc(row, rowIndex)
                      "
                      [value]="row"
                      class="p-datatable-icon-button-space"
                      [disabled]="isReadonly"
                    >
                    </p-tableCheckbox>
                  </ng-container>
                  <ng-container *ngIf="editable">
                    <ng-container
                      *ngIf="complex && editWithDialog; else rowEditMode"
                    >
                      <button
                        *ngIf="
                          !editing &&
                          !row.create &&
                          displayRowEditBtnFunc(row, rowIndex)
                        "
                        pButton
                        [disabled]="selection.length > 0"
                        icon="pi pi-pen"
                        (click)="onRowEditDialogInit(row)"
                        class="p-button-rounded p-button-text"
                      ></button>
                    </ng-container>
                    <ng-template #rowEditMode>
                      <button
                        *ngIf="
                          !editing &&
                          !row.create &&
                          displayRowEditBtnFunc(row, rowIndex)
                        "
                        pButton
                        pInitEditableRow
                        [disabled]="
                          selection.length > 0 || (singleEdit && isTableEditing)
                        "
                        icon="pi pi-pen"
                        (click)="onRowEditInit(row, rowIndex)"
                        class="p-button-rounded p-button-text"
                      ></button>
                    </ng-template>
                    <button
                      *ngIf="editing && !row.create"
                      pButton
                      pSaveEditableRow
                      icon="pi pi-confirm"
                      (click)="onRowEditSave(row, rowIndex)"
                      class="p-button-rounded p-button-text p-button-success p-datatable-icon-button-space"
                    ></button>
                    <button
                      *ngIf="editing && !row.create"
                      pButton
                      pCancelEditableRow
                      icon="pi pi-cancel"
                      (click)="onRowEditCancel(row, rowIndex)"
                      class="p-button-rounded p-button-text"
                    ></button>
                    <ng-container *ngIf="row.create">
                      <button
                        pButton
                        pSaveEditableRow
                        icon="pi pi-confirm"
                        (click)="onRowCreateSave(row)"
                        class="p-button-rounded p-button-text p-button-success p-datatable-icon-button-space"
                      ></button>
                      <button
                        pButton
                        pCancelEditableRow
                        icon="pi pi-cancel"
                        (click)="onRowCreateCancel(row, rowIndex)"
                        class="p-button-rounded p-button-text"
                      ></button>
                    </ng-container>
                  </ng-container>
                </div>
              </td>
              <ng-container *ngTemplateOutlet="bodyContainer"></ng-container>
            </tr>
          </ng-container>
          <ng-template #unSelectableRow>
            <tr
              [pEditableRow]="row"
              [class.p-editing]="editing && showHighlightColor"
              [class.p-highlight]="row.create && showHighlightColor"
            >
              <td
                [ngStyle]="
                  scrollable && frozenColCount > 0
                    ? calcFrozenColumnStyles(0, false, true)
                    : {}
                "
              >
                <div class="p-d-flex p-ai-center p-jc-center">
                  <ng-container *ngIf="selectable">
                    <p-tableCheckbox
                      *ngIf="!editing && !row.create"
                      [value]="row"
                      class="p-datatable-icon-button-space"
                      [ngStyle]="{
                        visibility: displayRowChkboxFunc(row, rowIndex)
                          ? 'visible'
                          : 'hidden'
                      }"
                      [disabled]="isReadonly"
                    >
                    </p-tableCheckbox>
                  </ng-container>
                  <ng-container *ngIf="editable">
                    <ng-container
                      *ngIf="complex && editWithDialog; else rowEditMode"
                    >
                      <button
                        *ngIf="
                          !editing &&
                          !row.create &&
                          displayRowEditBtnFunc(row, rowIndex)
                        "
                        pButton
                        [disabled]="selection.length > 0"
                        icon="pi pi-pen"
                        (click)="onRowEditDialogInit(row)"
                        class="p-button-rounded p-button-text"
                      ></button>
                    </ng-container>
                    <ng-template #rowEditMode>
                      <button
                        *ngIf="
                          !editing &&
                          !row.create &&
                          displayRowEditBtnFunc(row, rowIndex)
                        "
                        pButton
                        pInitEditableRow
                        [disabled]="
                          selection.length > 0 || (singleEdit && isTableEditing)
                        "
                        icon="pi pi-pen"
                        (click)="onRowEditInit(row, rowIndex)"
                        class="p-button-rounded p-button-text"
                      ></button>
                    </ng-template>
                    <button
                      *ngIf="editing && !row.create"
                      pButton
                      pSaveEditableRow
                      icon="pi pi-confirm"
                      (click)="onRowEditSave(row, rowIndex)"
                      class="p-button-rounded p-button-text p-button-success p-datatable-icon-button-space"
                    ></button>
                    <button
                      *ngIf="editing && !row.create"
                      pButton
                      pCancelEditableRow
                      icon="pi pi-cancel"
                      (click)="onRowEditCancel(row, rowIndex)"
                      class="p-button-rounded p-button-text"
                    ></button>
                    <ng-container *ngIf="row.create">
                      <button
                        pButton
                        pSaveEditableRow
                        icon="pi pi-confirm"
                        (click)="onRowCreateSave(row)"
                        class="p-button-rounded p-button-text p-button-success p-datatable-icon-button-space"
                      ></button>
                      <button
                        pButton
                        pCancelEditableRow
                        icon="pi pi-cancel"
                        (click)="onRowCreateCancel(row, rowIndex)"
                        class="p-button-rounded p-button-text"
                      ></button>
                    </ng-container>
                  </ng-container>
                </div>
              </td>
              <ng-container *ngTemplateOutlet="bodyContainer"></ng-container>
            </tr>
          </ng-template>
        </ng-container>
        <ng-template #bodyContainer>
          <ng-container
            *ngTemplateOutlet="
              bodyTemplate;
              context: {
                $implicit: row,
                rowIndex: rowIndex,
                columns: columns,
                expanded: expanded,
                editing: editing
              }
            "
          >
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td class="p-text-center p-no-data" [attr.colspan]="colSpanCount">
          {{ 'No Data' | translate }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      {{ 'Rows Per Page' | translate }}
    </ng-template>
    <ng-template pTemplate="summary">
      <div
        *ngIf="!paginator && !hideTotalRecordsReport"
        class="p-paginator p-component p-datatable-paginator"
      >
        <span class="p-paginator-current">{{
          'Total {totalRecords} Records'
            | translate : { totalRecords: this.totalRecords.toString() }
        }}</span>
      </div>
    </ng-template>
  </p-table>
  <div *ngIf="canCreateRow" class="p-text-center mt-20">
    <button
      pButton
      label="{{ 'Add' | translate }}"
      icon="pi pi-add-white"
      class="p-button-secondary p-content-button"
      [disabled]="hasUnConfirmedNewRows || (singleEdit && isTableEditing)"
      (click)="onCreateRowBtnClick()"
    ></button>
  </div>
</div>
